(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collections-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
    const sections = document.querySelectorAll('.section-resource-list');
    sections.forEach(section => {
      const navigation = section.querySelector('.collections-navigation');
      if (!navigation) return;
      
      const radios = navigation.querySelectorAll('input[type="radio"]');
      const tabs = section.querySelectorAll('.collection-tab');
      
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const collectionIndex = radio.dataset.collectionIndex;
          
          tabs.forEach(tab => {
            const isActive = tab.dataset.collectionIndex === collectionIndex;
            tab.classList.toggle('is-active', isActive);
          });
        });
      });
      
      // Set initial active state
      const checkedRadio = navigation.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const initialIndex = checkedRadio.dataset.collectionIndex;
        tabs.forEach(tab => {
          tab.classList.toggle('is-active', tab.dataset.collectionIndex === initialIndex);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linked-products"] && !Shopify.designMode) return;
  try {
    class LinkedProducts extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('[data-linked-products-list]');
      this.toggle = this.querySelector('[data-linked-products-toggle]');
      this.selected = this.querySelector('[data-selected-colour]');
      if (!this.list) return;
      this.collapsed = true;
      this.collapsedMax = null;
      this.defaultColour = this.selected ? this.selected.textContent.trim() : '';
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.list);
      if (this.toggle) this.toggle.addEventListener('click', () => this.toggleExpand());
      this.bindHover();
      requestAnimationFrame(() => this.measure());
    }

    gap() {
      const cs = getComputedStyle(this.list);
      return parseFloat(cs.rowGap || cs.gap) || 0;
    }

    rowTops() {
      const items = Array.from(this.list.querySelectorAll('[data-linked-product-item]'));
      const tops = Array.from(new Set(items.map(function (i) { return Math.round(i.offsetTop); })));
      tops.sort(function (a, b) { return a - b; });
      return tops;
    }

    measure() {
      const tops = this.rowTops();
      if (tops.length > 2) {
        this.collapsedMax = (tops[2] - tops[0]) - this.gap();
        if (this.toggle) this.toggle.hidden = false;
      } else {
        this.collapsedMax = null;
        if (this.toggle) this.toggle.hidden = true;
      }
      this.apply();
    }

    apply() {
      if (this.collapsed && this.collapsedMax) {
        this.list.style.maxHeight = this.collapsedMax + 'px';
      } else {
        this.list.style.maxHeight = this.list.scrollHeight + 'px';
      }
    }

    toggleExpand() {
      this.collapsed = !this.collapsed;
      this.toggle.setAttribute('aria-expanded', String(!this.collapsed));
      const more = this.toggle.querySelector('[data-toggle-more]');
      const less = this.toggle.querySelector('[data-toggle-less]');
      if (more && less) { more.hidden = !this.collapsed; less.hidden = this.collapsed; }
      this.apply();
    }

    bindHover() {
      if (!this.selected) return;
      const self = this;
      this.list.addEventListener('mouseover', function (e) {
        const item = e.target.closest('[data-linked-product-item]');
        if (item && item.dataset.colour) self.selected.textContent = item.dataset.colour;
      });
      this.list.addEventListener('mouseleave', function () {
        self.selected.textContent = self.defaultColour;
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  customElements.define('linked-products', LinkedProducts);
  } catch(e) { console.error(e); }
})();

})();
